import { render, staticRenderFns } from "./CRTextArea.vue?vue&type=template&id=a68923fa&scoped=true"
import script from "./CRTextArea.vue?vue&type=script&lang=js"
export * from "./CRTextArea.vue?vue&type=script&lang=js"
import style0 from "./CRTextArea.vue?vue&type=style&index=0&id=a68923fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68923fa",
  null
  
)

export default component.exports